import { useMemo } from 'react'
import { OrderType } from 'types/checkout'
import { StoreShippingType } from 'types/storeShipping'

const useSumDeliveryOrderAmount = (storeShippingList: StoreShippingType[], orders: OrderType[]): number => {
  return useMemo(() => {
    return orders.reduce((prev, order) => {
      if (storeShippingList.some((storeShipping) => storeShipping.store_checkout_ref.id === order.checkout_id)) {
        return prev + 1
      } else {
        return prev
      }
    }, 0)
  }, [orders, storeShippingList])
}

export default useSumDeliveryOrderAmount
